import { useEffect, useState } from "react";
import { MESSENGER_IDS, MESSENGERS, isMessengerId } from "../utils/messengers";
import { MaxBrandIcon, TelegramBrandIcon } from "./MessengerBrandIcons";
import { getApiBaseUrl, readApiJson } from "../utils/apiBase";
import { setAuthToken } from "../utils/tokenHeaders";

const MESSENGER_ICONS = {
  telegram: TelegramBrandIcon,
  max: MaxBrandIcon,
};

export default function MessengerSelector({
  value,
  onChange,
  label = "Мессенджер для команды",
  hint,
  compact = false,
}) {
  const resolvedValue = isMessengerId(value) ? value : "telegram";
  const [selected, setSelected] = useState(resolvedValue);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setSelected(isMessengerId(value) ? value : "telegram");
  }, [value]);

  const handleSelect = async (messengerId) => {
    if (messengerId === selected || saving) return;

    const previous = selected;
    setSelected(messengerId);
    setSaving(true);
    setError(null);

    try {
      if (onChange) {
        await onChange(messengerId);
      }
    } catch (err) {
      setSelected(previous);
      setError(err?.message || "Не удалось сохранить мессенджер");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div
      className={`app-messenger-select${
        compact ? " app-messenger-select--compact" : ""
      }${saving ? " app-messenger-select--saving" : ""}`}
    >
      {!compact || label ? (
        <span className="app-messenger-select__label">{label}</span>
      ) : null}
      {hint && !compact ? (
        <p className="app-messenger-select__hint">{hint}</p>
      ) : null}
      {error ? <p className="app-messenger-select__error">{error}</p> : null}
      <div className="app-messenger-select__options" role="radiogroup" aria-label={label}>
        {MESSENGER_IDS.map((id) => {
          const meta = MESSENGERS[id];
          const isActive = selected === id;
          const BrandIcon = MESSENGER_ICONS[id];

          return (
            <button
              key={id}
              type="button"
              role="radio"
              aria-checked={isActive}
              disabled={saving}
              className={`app-messenger-select__option${
                isActive ? " app-messenger-select__option--active" : ""
              }`}
              onClick={() => handleSelect(id)}
            >
              <span className="app-messenger-select__option-head">
                <BrandIcon
                  className="app-messenger-select__option-icon"
                  size={compact ? 28 : 32}
                />
                <span className="app-messenger-select__option-title">
                  {meta.label}
                </span>
              </span>
              {!compact ? (
                <span className="app-messenger-select__option-desc">
                  {meta.shareHint}
                </span>
              ) : null}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export async function savePreferredMessenger(messengerId) {
  const response = await fetch(`${getApiBaseUrl()}/profile/messenger`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: setAuthToken(),
    },
    body: JSON.stringify({ messenger: messengerId }),
  });

  const data = await readApiJson(response);

  if (!response.ok) {
    throw new Error(data.message || "Не удалось сохранить мессенджер");
  }

  return data;
}
